import React from 'react'
import { Create } from 'react-admin'

import EsquemaForm from './EsquemaForm'


export const EsquemaCreate = props => (
    <Create {...props}>
        <EsquemaForm redirect="list"/>
    </Create>
);
